import * as Utils from '../../modules/Utils'

export default class ManagerModel {
  constructor (data) {
    this.key = data.id.toString()
    this.email = data.email
    this.name = data.firstName + ' ' + data.lastName
    this.tags = data.tags
    this.id = data.id
    this.internalId = data.internalId
    this.birthDate = data.birthDate
    this.formattedBirthDate = data.birthDate ? Utils.dateToString(data.birthDate) : ''
  }
}



// WEBPACK FOOTER //
// ./src/api/tags/ManagerModel.js